export default __webpack_public_path__ + "static/media/espacoAluno.bf902f6a.png";